import { render, staticRenderFns } from "./Project.vue?vue&type=template&id=5b6efc30&"
import script from "./Project.vue?vue&type=script&lang=ts&"
export * from "./Project.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports